// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"2bcc49a6","425":"a0c78fd8","438":"4b431577","488":"d41aeb0c","938":"25cf857b"}[chunkId] + ".chunk.js";
};